<template>
  <svg viewBox="0 0 24 24" class="w-6 h-6 fill-current">
    <path
      fill-rule="evenodd"
      d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "NavIcon",
  props: {
    color: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
